<template>
  <div>
    <v-btn
      large
      class="mt-5 mx-3 white--text"
      color="red darken-1"
      @click="openInformes()"
      >INFORMES</v-btn
    >
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.lgAndDown"
      max-width="800"
    >
      <v-card color="white" class="py-4" tile>
        <v-card-title class="d-flex flex-column justify-start align-start">
          <v-btn
            pa-0
            @click="(dialog = !dialog), (information.campus = null)"
            style="
              min-width: 2rem !important;
              min-height: 2rem !important;
              max-width: 2rem !important;
              max-height: 2rem !important;
              border-radius: 50% !important;
              margin-left: auto !important;
            "
          >
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
          <h1
            :class="[
              $vuetify.breakpoint.mdAndUp
                ? 'display-3 px-12'
                : 'display-1 px-2',
            ]"
            class="text-uppercase mb-4"
          >
            Obtén informes
          </h1>
          <h3
            class="title word-wrap"
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2']"
          >
            ¡Nosotros nos pondremos en contacto contigo!
          </h3>
        </v-card-title>

        <v-card-actions>
          <v-layout
            :row="$vuetify.breakpoint.mdAndUp"
            class="mx-0"
            :column="$vuetify.breakpoint.smAndDown"
          >
            <v-flex
              xs12
              :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6" class="pr-6">
                    <v-text-field
                      class="mb-5"
                      label="PRIMER NOMBRE*"
                      placeholder="Juan"
                      v-model="information.name_first"
                      type="text"
                      id="name_first"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="SEGUNDO NOMBRE"
                      placeholder="Pérez"
                      v-model="information.name_second"
                      type="text"
                      id="name_second"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="APELLIDO PATERNO*"
                      placeholder="López"
                      v-model="information.last_name"
                      type="text"
                      id="lastname"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="APELLIDO MATERNO*"
                      placeholder="Garcia"
                      v-model="information.mother_last_name"
                      type="text"
                      id="lastname"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="CORREO ELECTRÓNICO*"
                      v-model="information.email"
                      placeholder="correo@ejemplo.com"
                      type="email"
                      id="email"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="NÚMERO TELEFÓNICO*"
                      placeholder="(123)-123-1212"
                      v-model="information.phone"
                      v-mask="'(###)-###-####'"
                      type="phone"
                      id="phone"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="LOCALIDAD*"
                      v-model="information.localidad"
                      type="phone"
                      id="phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" class="pl-6">
                    <p class="body-1 text-uppercase">
                      Deseo información sobre:
                    </p>
                    <v-select
                      class="mt-8 mb-4"
                      :items="campus"
                      label="EN EL PLANTEL*"
                      hide-details
                      outlined
                      v-model="information.campus"
                    ></v-select>
                    <p class="body-1 text-uppercase">
                      Escoge el grado de tu interés:*
                    </p>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.comunidad_infantil"
                      label="Comunidad Infantil"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.preescolar"
                      label="Preescolar"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.primaria"
                      label="Primaria"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.secundaria"
                      label="Secundaria"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.preparatoria"
                      label="Preparatoria"
                    ></v-checkbox>
                    <v-textarea
                      label="Mensaje*"
                      rows="6"
                      counter="200"
                      no-resize
                      v-model="information.message"
                      id="lastname"
                    ></v-textarea>
                    <v-select
                      class="mt-8 mb-4"
                      :items="way"
                      label="¿Cómo te enteraste de nosotros?*"
                      hide-details
                      outlined
                      v-model="information.way"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    class="d-flex flex-column justify-end align-end"
                  >
                    <vue-recaptcha
                      @expired="successRecaptcha = false"
                      @verify="reCAPTCHAcallback()"
                      sitekey="6Ldup2AkAAAAAKMM1piarFf0izdo1x_yhWCJOE3t"
                      :loadRecaptchaScript="true"
                    ></vue-recaptcha>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-layout
                  :row="$vuetify.breakpoint.mdAndUp"
                  :column="$vuetify.breakpoint.smAndDown"
                  :reverse="$vuetify.breakpoint.smAndDown"
                >
                  <div
                    class="flex-grow-1"
                    v-if="$vuetify.breakpoint.mdAndUp"
                  ></div>
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    text
                    class="px-5"
                    @click="(dialog = !dialog), (information.campus = null)"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    color="primary"
                    class="px-5"
                    :disabled="isLoading || !successRecaptcha"
                    @click="submitData()"
                    >Enviar formulario</v-btn
                  >
                </v-layout>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :right="false">
        {{ snackbarText }}
        <v-btn color="red" dark text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </v-dialog>
    <v-dialog
      v-model="dialogInformes"
      :fullscreen="$vuetify.breakpoint.lgAndDown"
      max-width="800"
    >
      <v-card color="white" class="py-4" tile>
        <v-card-title class="d-flex flex-column justify-start align-start">
          <v-btn
            style="
              min-width: 2rem !important;
              min-height: 2rem !important;
              max-width: 2rem !important;
              max-height: 2rem !important;
              border-radius: 50% !important;
              margin-left: auto !important;
            "
            pa-0
            @click="
              (dialogInformes = !dialogInformes), (information.campus = null)
            "
          >
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
          <h1
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'display-3 ' : 'display-1 px-2',
            ]"
            class="text-uppercase mb-4 word-wrap"
          >
            Solicitud de cita
          </h1>
          <br />
          <h3
            class="title word-wrap"
            :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-2']"
          >
            Puedes solicitar una cita previa para conocer nuestras instalaciones
            y programas utilizando el siguiente calendario.
          </h3>
          <h5
            class="instructions word-wrap mt-4"
            :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
          >
            1.- Selecciona el día y la hora en que quieras reunirte con
            nosotros.
          </h5>
          <h5
            class="instructions word-wrap mt-4"
            :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
          >
            2.- Deja tus datos para ponernos en contacto y agendarte.
          </h5>
          <h5
            class="instructions word-wrap mt-4"
            :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
          >
            3.- Recibirás un correo confirmando tu cita.
          </h5>
          <h5
            class="instructions word-wrap mt-4"
            :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-4']"
          >
            4.- Si finalmente no puedes asistir a la cita, te solicitamos de
            favor te pongas en contacto con nosotros a través del email
            <b>contacto_colegio@uva.edu.mx</b> o puedes llamarnos al
            <b>01 800 832 3245</b>.
          </h5>
        </v-card-title>
        <v-layout
          :row="$vuetify.breakpoint.mdAndUp"
          class="mx-0"
          :column="$vuetify.breakpoint.smAndDown"
        >
          <v-flex
            xs12
            :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
          >
            <v-card-text>
              <v-row class="text-center">
                <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                  <h2 class="instructions">Escoge la fecha para tu cita:</h2>
                  <v-date-picker
                    v-model="picker"
                    color="primary"
                    class="mt-5"
                    locale="es"
                    :width="$vuetify.breakpoint.lgAndUp ? '600' : 'auto'"
                  ></v-date-picker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                  <h2 class="instructions">Selecciona un horario:</h2>
                  <v-select
                    class="mt-8 mb-4"
                    :items="horarios"
                    label="HORARIO"
                    hide-details
                    outlined
                    v-model="information.horarios"
                  ></v-select>
                  <v-select
                    class="mt-8 mb-4"
                    :items="campus"
                    label="EN EL PLANTEL"
                    hide-details
                    outlined
                    v-model="information.campus"
                  ></v-select>
                  <h2 class="instructions">Escoge el grado de tu interés:</h2>
                  <v-checkbox
                    dense
                    hide-details
                    v-model="information.comunidad_infantil"
                    label="Comunidad Infantil"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    v-model="information.preescolar"
                    label="Preescolar"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    v-model="information.primaria"
                    label="Primaria"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    v-model="information.secundaria"
                    label="Secundaria"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    v-model="information.preparatoria"
                    label="Preparatoria"
                  ></v-checkbox>
                  <v-textarea
                    label="Mensaje"
                    rows="6"
                    counter="200"
                    no-resize
                    v-model="information.message"
                    id="lastname"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <h2 class="instructions">Rellena con tu información:</h2>
              </v-row>
              <v-col cols="12" lg="12" sm="12" md="12" class="pl-6">
                <v-text-field
                  class="mb-5"
                  label="PRIMER NOMBRE"
                  placeholder="Juan"
                  v-model="information.name_first"
                  type="text"
                  id="name_first"
                ></v-text-field>
                <v-text-field
                  class="mb-5"
                  label="SEGUNDO NOMBRE"
                  placeholder="Pérez"
                  v-model="information.name_second"
                  type="text"
                  id="name_second"
                ></v-text-field>
                <v-text-field
                  class="mb-5"
                  label="APELLIDO PATERNO"
                  placeholder="López"
                  v-model="information.last_name"
                  type="text"
                  id="lastname"
                ></v-text-field>
                <v-text-field
                  class="mb-5"
                  label="APELLIDO MATERNO"
                  placeholder="Garcia"
                  v-model="information.mother_last_name"
                  type="text"
                  id="lastname"
                ></v-text-field>
                <v-text-field
                  class="mt-5"
                  label="CORREO ELECTRÓNICO"
                  v-model="information.email"
                  placeholder="correo@ejemplo.com"
                  type="email"
                  id="email"
                ></v-text-field>
                <v-text-field
                  class="mt-5"
                  label="NÚMERO TELEFÓNICO"
                  placeholder="(123)-123-1212"
                  v-model="information.phone"
                  v-mask="'(###)-###-####'"
                  type="phone"
                  id="phone"
                ></v-text-field>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
              >
                <div
                  class="flex-grow-1"
                  v-if="$vuetify.breakpoint.mdAndUp"
                ></div>
                <v-btn
                  rounded
                  text
                  class="px-5"
                  @click="
                    (dialogInformes = !dialogInformes),
                      (information.campus = null)
                  "
                  >Cancelar</v-btn
                >
                <v-btn
                  rounded
                  color="primary"
                  class="px-5"
                  @click="submitDate()"
                  >Enviar formulario</v-btn
                >
              </v-layout>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.animated {
  -webkit-animation: pulse 0.5s infinite alternate;
  animation: pulse 0.5s infinite alternate;
}
@-webkit-keyframes pulse {
  to {
    -webkit-transform: scale(1.1);
  }
}
@keyframes pulse {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
<script>
import { mask } from "vue-the-mask";
import axios from "axios";
export default {
  directives: {
    mask,
  },
  data: () => ({
    successRecaptcha: false,
    isLoading: false,
    snackbar: false,
    snackbarColor: "",
    snackbarText: "",
    picker: new Date().toISOString().substr(0, 10),
    isOnHover: false,
    dialogInformes: false,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      horarios: "",
      localidad: "",
      message: "",
      preescolar: false,
      primaria: false,
      secundaria: false,
      preparatoria: false,
      comunidad_infantil: false,
      escolaridad: "",
      way: "",
    },
    way: [
      "Redes sociales",
      "Recomendación",
      "Feria educativa",
      "Saloneo",
      "Publicidad",
      "Radio",
      "Folletos",
      "Página web",
      "Open house",
    ],
    campus: [
      "Cd. Obregón",
      "Ensenada",
      "Manzanillo",
      "Monclova",
      "Puerto Vallarta",
      "Tepic",
      "Torreón",
      "Colima",
      "Guaymas",
      "Mexicali",
      "Piedras Negras",
      "Saltillo",
      "Tijuana",
    ],
    horarios: [
      "8:00 am - 8:30 am",
      "8:30 am - 9:00 am",
      "9:00 am - 9:30 am",
      "9:30 am - 10:00 am",
      "10:00 am - 10:30 am",
      "10:30 am - 11:00 am",
      "11:00 am - 11:30 am",
      "11:30 am - 12:00 am",
      "12:00 am - 12:30 am",
      "12:30 pm - 1:00 pm",
    ],
    dialog: false,
  }),
  methods: {
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    openInformes() {
      this.dialog = !this.dialog;
      gtag("event", "conversion", {
        send_to: "AW-673462129/rnQZCMXM5dIBEPHukMEC",
        event_callback: () => {
          console.log("col-inf-form");
        },
      });
    },
    imageover() {
      this.isOnHover = true;
    },
    imageleave() {
      this.isOnHover = false;
    },
    submitData() {
      this.information.escolaridad = "";
      let escola = false;
      if (this.information.preescolar) {
        escola = true;
      }
      if (this.information.primaria) {
        escola = true;
      }
      if (this.information.secundaria) {
        escola = true;
      }
      if (this.information.preparatoria) {
        escola = true;
      }
      if (this.information.comunidad_infantil) {
        escola = true;
      }
      if (!escola) {
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        return;
      }
      this.validateFieldsI();
      if (this.valid == true) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        if (this.information.primaria) {
          this.information.escolaridad += "Primaria ";
        }
        if (this.information.preescolar) {
          this.information.escolaridad += "Preescolar ";
        }
        if (this.information.secundaria) {
          this.information.escolaridad += "Secundaria ";
        }
        if (this.information.preparatoria) {
          this.information.escolaridad += "Preparatoria ";
        }
        if (this.information.comunidad_infantil) {
          this.information.escolaridad += "Comunidad Infantil ";
        }
        this.sendInfoData();
      }
    },
    submitDate() {
      this.validateFieldsC();
      if (this.valid == true) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        if (this.information.licenciatura) {
          this.information.escolaridad += "Licenciatura, ";
        }
        if (this.information.posgrado) {
          this.information.escolaridad += "Posgrados, ";
        }
        if (this.information.otros) {
          this.information.escolaridad += "Otros. ";
        }
        this.sendInfoDate();
      }
    },
    validateFieldsI() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.campus != "" &&
        this.information.localidad != "" &&
        this.information.way != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar los campos";
        this.snackbar = true;
      }
    },
    validateFieldsC() {
      if (
        this.information.name_first != "" &&
        // this.information.name_second != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.campus != "" &&
        this.information.horarios != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar los campos";
        this.snackbar = true;
      }
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        localidad: "",
        message: "",
        secundaria: false,
        preparatoria: false,
        otros: false,
        escolaridad: "",
        horarios: "",
        way: "",
      };
      this.dialog = false;
      this.dialogInformes = false;
    },
    sendInfoData() {
      gtag("event", "conversion", {
        send_to: "AW-673462129/MtRhCIHr2MUBEPHukMEC",
        event_callback: () => {
          console.log("col-det-form");
        },
      });
      var self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("municipality", this.information.localidad);
      formData.append("campus", this.information.campus);
      formData.append("message", this.information.message);
      formData.append("carreer", this.information.carrer);
      formData.append("subject", "Informes");
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("procedence", this.information.school);
      formData.append("comunication", this.information.way);
      formData.append("webpage", "Colegio");
      axios({
        method: "post",
        url: "https://informesuva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then((response) => {
          if (response.data.status == "200") {
            self.snackbarText =
              "Informe agendado, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.$router.push("/gracias-informes");
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Se ha producido un error, intentelo de nuevo mas tarde.";
            self.snackbarColor = "warning";
            self.snackbar = true;
          }
          self.isLoading = false;
        })
        .catch(function (error) {
          self.isLoading = false;
        });
    },
    sendInfoDate() {
      var self = this;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("campus", this.information.campus);
      formData.append("carreer", this.information.carrer);
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("webpage", "Colegio");
      formData.append("to_hour", this.information.horarios);
      formData.append("to_date", this.picker);
      axios({
        method: "post",
        url: "https://adminuva.tidingo.com/api/create-cite",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function (response) {
          if (response.data.status == "200") {
            self.snackbarText =
              "Cita agendada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Se ha producido un error, intentelo de nuevo mas tarde.";
            self.snackbarColor = "warning";
            self.snackbar = true;
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    validateEmail(email) {
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone =
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
  },
};
</script>